import { header } from "./modules/header";
import { handleFormSubmit } from './modules/form';
import { smoothScroll } from "./modules/smooth-scroll";
import AOS from 'aos';
import "./button-top";

document.addEventListener("DOMContentLoaded", function () {
  header().init();
  handleFormSubmit().init();
  smoothScroll();
  AOS.init();
})
